import Cookies from "js-cookie";
import apiGuard from "../../../context-controller-mod/context-serv/global-provider/api-shell/api-gaurd";

const ApiGetRealtime = (
  path: string,
  eventName: string,
  onMessage: (data: unknown) => void,
  onError?: (e: unknown) => void,
): () => void => {
  let active = true;
  const controller = new AbortController();

  const baseUrl = apiGuard.defaults.baseURL ?? /* istanbul ignore next */ '';
  const token = Cookies.get('access_token') ?? '';

  const url = `${baseUrl}${path}?key=${eventName}`;

  const headers: Record<string, string> = {
    Accept: 'text/event-stream',
  };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  (async () => { //NOSONAR
    try {
      const response = await fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers,
        signal: controller.signal,
      });

      if (!response.ok || !response.body) {
        throw new Error(`[SSE] bad response: ${response.status}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';

      while (active) {
        const { value, done } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });

        // Split on double newline — each SSE message block
        const parts = buffer.split('\n\n');
        buffer = parts.pop() ?? /* istanbul ignore next */ '';

        for (const part of parts) {
          // Collect all data: lines and join (handles multi-line data)
          const raw = part
            .split('\n')
            .filter((l) => l.startsWith('data:'))
            .map((l) => l.slice(5).trim())
            .join('');

          if (!raw) continue;

          try {
            const outer = JSON.parse(raw);

            // Parse the nested message string → { module, message }
             /* istanbul ignore next */
            if (typeof outer.message === 'string') {
              try {
                outer.message = JSON.parse(outer.message);
              } catch {
                // leave as raw string if not JSON
              }
            }

            onMessage(outer);
          } catch {
            console.error('[SSE] parse error:', raw);
          }
        }
      }
    } catch (e) {
      if ((e as Error)?.name === 'AbortError') return;
      console.error('[SSE] stream error:', e);
      onError?.(e);
    }
  })();

  return () => {
    active = false;
    controller.abort();
  };
};

export default ApiGetRealtime;